module.exports = __webpack_public_path__ + "img/logo_rsw.4eae878f.png";